(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('catalogService', catalogService);

    function catalogService($http, $q, $timeout, portalUrl, tokenService, userService, cgbusyService) {

        var _cache = {};
        var catalogItemPromise;

        return {
            getCatalogItems: getCatalogItems,
            startElearning: startElearning,
            restartElearning: restartElearning
        };
    
        function getCatalogItems() {

            if (_cache.expires !== undefined && _cache.expires > Date.now()) {
                return $q.resolve(_cache.catalogItems);
            }
            
            return cgbusyService.blockUI(
                tokenService.getToken().then(() => {
                    return $http.get(portalUrl + '/api/1.0/catalogItem/NameAndType', { cache: true }).then(
                        response => {
                            var now = new Date();
                            
                            _cache.catalogItems = response.data.map(item => { return { targetId: item.targetId, targetType: item.targetType, name: item.name }; });
                            _cache.expires = now.setMinutes(now.getMinutes() + 5);

                            return $q.resolve(_cache.catalogItems);
                        },
                        response => {
                            return $q.reject(response);
                        }
                    );
                }));
        }

        /**
         * @param learningPlanId test
         */
        function startElearning(learningPlanId) {
            return cgbusyService.blockUI(tokenService.getToken()
                .then(() => userService.getUser())
                .then(userData => $http.post(portalUrl + '/api/1.0/LearningPlan', {
                    learningPlanId: learningPlanId,
                    idString: userData.idString
                }))
                .then(
                    response => { return response.data.startUrl; },
                    response => { return $q.reject(response.data); }
                ));
        }

        function restartElearning(learningPlanId) {
            return cgbusyService.blockUI(tokenService.getToken()
                .then(() => userService.getUser())
                .then(userData => $http.post(portalUrl + '/api/1.0/LearningPlan/ReEnroll', {
                    learningPlanId: learningPlanId,
                    idString: userData.idString
                }))
                .then(
                    response => { return response.data.startUrl; },
                    response => { return $q.reject(response.data); }
                ));
        }
    }
})();